// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInboxGetUnreadCountBody = {};

export type typeInboxGetUnreadCountOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { unreadCount: number; refreshAfterSeconds: number };
};

export type typeInboxGetUnreadCountOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInboxGetUnreadCountOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInboxGetUnreadCountOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInboxGetUnreadCountBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInboxGetUnreadCount(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInboxGetUnreadCountBody);
  }

  return async function postInboxGetUnreadCount(
    payload: typeInboxGetUnreadCountBody,
  ): Promise<
    typeInboxGetUnreadCountOutput200 | typeInboxGetUnreadCountOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInboxGetUnreadCount" failed before calling the network. #c97a0ae3f4f1`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#c97a0ae3f4f1" },
        },
        data: null,
      } as typeInboxGetUnreadCountOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/inbox/get-unread-count`,
      httpMethod: "POST",
      options,
    })) as typeInboxGetUnreadCountOutput200 | typeInboxGetUnreadCountOutput400;
  };
}
